module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('GroupBase', [(_vm.loading) ? _c('Loader') : (_vm.teams.length > 0) ? _c('div', _vm._l((_vm.teams), function(team) {
    return _c('GroupElement', {
      key: team.id,
      attrs: {
        "name": team.name,
        "id": team.id,
        "isMember": team.is_member,
        "privacySetting": team.privacy_setting
      }
    })
  })) : _c('p', {
    staticClass: "text-muted fs-6 text-center"
  }, [_vm._v("You're not a member of any groups yet!")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-601bc6e2"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyGroups.vue
// module id = 1045
// module chunks = 0